import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import Thumb from "./Thumb";

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

function FileUpload(props) {
  const [files, setFiles] = useState(props.files ? props.files : []);
  const onDrop = acceptedFiles => {
    const newFiles = Object.assign([], files);
    acceptedFiles.forEach(file => {
      newFiles.push(Object.assign(file, {
        preview: '/dist/assets/img/loading.png',
        status: 'LOADING'
      }));
      setFiles(newFiles);
      const reader = new FileReader();
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        axios.post('/api/file-upload?name=' + encodeURIComponent(file.name), reader.result, {
          headers: {
            'Content-Type': file.type
          }
        }).then(r => {
          file.status = 'READY';
          file.serverPath = r.data.path;
          file.preview = r.data.preview;
          const newerFiles = Object.assign([], newFiles);
          setFiles(newerFiles);
        })
      };
      reader.readAsArrayBuffer(file);
    });
  };
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: 'image/*',
    noClick: true,
    noKeyboard: true
  });
  const thumbs = files.map((file, idx) => (
    <Thumb id={idx} file={file} onDelete={() => {
      const newFiles = Object.assign([], files);
      _.remove(newFiles, fl => fl === file)
      setFiles(newFiles);
    }} />
  ));
  useEffect(() => {
    props.updateFileList !== undefined && props.updateFileList(files);
  }, [files]);
  const { children } = props;
  return (
    <div style={{ border: '1px solid #dedede', padding: '1em', fontSize: '90%', marginBottom: '2em' }}>
      <div {...getRootProps()} >
        <input {...getInputProps()} />
        {children}
        <button type="button" className="button expanded hollow" onClick={open}>
          <i className="fas fa-plus-square"></i> Dodaj zdjęcia
        </button>
      </div>
      <div style={thumbsContainer}>
        {thumbs}
      </div>
    </div>);
}

export default FileUpload;
